import script from "./CheckoutClienteData.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutClienteData.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutClienteData.vue?vue&type=style&index=0&id=973101de&scoped=true&lang=css"

import exportComponent from "/media/alexandre/08eeec93-1efa-4ec5-9b9c-83fb7789c963/Projects/uniboi-app-2023/uniboi-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-973101de"]])

export default __exports__